export const SET_LOADING_LOG_TRANSAKSI = "SET_LOADING_LOG_TRANSAKSI";
export const SET_LOADING_LOG_PENGAJUAN = "SET_LOADING_LOG_PENGAJUAN";
export const SET_LOADING_LOG_AKTIFITAS_PENGGUNA = "SET_LOADING_LOG_AKTIFITAS_PENGGUNA";
export const LOG_TRANSAKSI = "LOG_TRANSAKSI";
export const LOG_PENGAJUAN = "LOG_PENGAJUAN";
export const LOG_AKTIFITAS_PENGGUNA = "LOG_AKTIFITAS_PENGGUNA";
export const STATISTIK = "STATISTIK";
